/* eslint-disable max-len */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AccreditationEditListModel } from 'src/types/AccreditationEditList';
import {
  getAccreditationEditsByCategory,
  getAccreditationEditsCount,
} from '../../services/accreditation.service';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import { AccreditationDashboardModel } from '../../types/AccreditationDashboardModel';

export const fetchAccreditationEditsCount = createAsyncThunk(
  'input/fetchAccreditationEditsCount',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      AccreditationDashboardModel[]
    >(thunkAPI, getAccreditationEditsCount({ signal: thunkAPI.signal }));
  }
);

export const fetchAccreditationEditItemsForCategory = createAsyncThunk(
  'input/fetchAccreditationEditItemsForCategory',
  async (category: string, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<AccreditationEditListModel>(
      thunkAPI,
      getAccreditationEditsByCategory(category, { signal: thunkAPI.signal })
    );
  }
);
